import { shallowMount, createLocalVue } from "@vue/test-utils";
import RecentInvoice from './RecentInvoice';
import VueRouter from 'vue-router';
import { currency } from '../../../../../filters';

const localVue = createLocalVue();
localVue.use(VueRouter);
localVue.filter('currency', currency);

let invoice = {
  shipping_status: 'processing',
  items: [{
    id: 123,
    subscription_id: 234,
    type: 'subscription'
  }, {
    id: 124,
    type: 'one-time'
  }, {
    id: 124,
    type: 'shipping'
  }],
  total: 21.95,
  tracking_url: 'http://some.com/blahblah'
};

const createWrapper = () => {
  return shallowMount(RecentInvoice, {
    localVue,
    propsData: { invoice }
  });
};


describe('RecentInvoice', () => {

  test('general snapshot', () => {
    let wrapper = createWrapper(invoice);
    expect(wrapper.html()).toMatchSnapshot();
  });

  describe('computed', () => {
    describe('orderDetailsUrl', () => {
      test('generate url with the right invoice id', () => {
        let localState = { invoice: { id: 123 }};
        let res = RecentInvoice.computed.invoiceDetailsUrl.call(localState);
        expect(res).toEqual('/dashboard/purchases/order-details/123');

        let localState2 = { invoice: { id: 124 }};
        let res2 = RecentInvoice.computed.invoiceDetailsUrl.call(localState2);
        expect(res2).toEqual('/dashboard/purchases/order-details/124');
      });
    });

    describe('subUrl', () => {
      test('generate url with the right subId', () => {
        let localState = { invoiceSubId: 234 };
        let res = RecentInvoice.computed.subUrl.call(localState);
        expect(res).toEqual('/dashboard/purchases/edit-auto-delivery/234');

        let localState2 = { invoiceSubId: 345 };
        let res2 = RecentInvoice.computed.subUrl.call(localState2);
        expect(res2).toEqual('/dashboard/purchases/edit-auto-delivery/345');
      });
    });

    describe('invoiceSubId', () => {
      test('return subscription_id from first item in invoice.items', () => {
        let localState = { invoice };
        let res = RecentInvoice.computed.invoiceSubId.call(localState);
        expect(res).toEqual(234);
      });
    });

    describe('trackFirst', () => {
      test('return true when invoice shipping_status is not "delivered"', () => {
        let localState = { invoice };
        let res = RecentInvoice.computed.trackFirst.call(localState);
        expect(res).toBe(true);
      });

      test('return false when invoice shipping_status is "delivered"', () => {
        let localState = {
          invoice: {
            shipping_status: "delivered"
          }
        };
        let res = RecentInvoice.computed.trackFirst.call(localState);
        expect(res).toBe(false);
      });

    });

    describe('invoiceItems', () => {
      test('filter out items that are type "shipping"', () => {
        let localState = { invoice };
        let res = RecentInvoice.computed.invoiceItems.call(localState);
        expect(res.length).toEqual(2);

        res.forEach(item => {
          expect(item.type).not.toMatch('shipping');
        });
      });

    });

  });

});
